import { render, staticRenderFns } from "./PeoplePicker.vue?vue&type=template&id=72c3ac47&"
import script from "./PeoplePicker.vue?vue&type=script&lang=js&"
export * from "./PeoplePicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports